import Popup from "../plugins/Popup";

$(document).ready(function () {
  $(document).on('click', '.popup__close', function () {
    Popup.get('#' + $(this).parents('.popup').get(0).id).close();
  });

  $(document).on('click', '[popup]', function (e) {

    e.preventDefault();
    const popup = $(this).attr('popup') ? '#' + $(this).attr('popup') : '#popup';

    Popup.get(popup).show($(this));

  });

  $(document).on('click', '.popup', function (e) {

    const target = $(e.target);

    if (target.hasClass('popup_active'))
      Popup.get('#' + target.get(0).id).close();

  });

  $('[popup="#popup-video"]').click(function () {

    const video = $('#popup-video').find('video');
    video.attr('src', '').attr('src', $(this).data('content'));
    video.get(0).load();
    video.get(0).play();

  });

  let player;

  $('[popup="popup-iframe"]').click(function () {

    const url = $(this).data('url');
    if (typeof YT !== 'undefined') {
      player = new YT.Player('iframe', {
        videoId: url,
        events: {
          'onReady': onPlayerReady
        }
      });
    }

  });

  $("#popup-iframe").on('popup-close', function () {
    stopVideo();
    $(this).find('.video').replaceWith(
      `<div class="video video_popup" id="iframe"></div>`
    );
  });

  function onPlayerReady(event) {
    event.target.playVideo();
  }

  function stopVideo() {
    player.stopVideo();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[popup="popup_test-drive-new"]')
    if (!btn) return

    const title = btn.getAttribute('popup-title')
    const popupId = btn.getAttribute('popup')

    const popup = document.getElementById(popupId)
    const titleEl = popup?.querySelector('.title div')

    if (title && titleEl) {
      titleEl.textContent = title
    }
  })

});
